import { useState, useEffect, FC } from 'react';
import { getRequest, postRequest } from '../utils/api';
import { Incident } from '../interfaces/incident';
import { Alert } from '../interfaces/alert';
import { formatDate } from '../utils/datetime';

const Alerts: FC = () => {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [incidents, setIncidents] = useState<Incident[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [pageSize] = useState<number>(10); // Fixed page size

  useEffect(() => {
    fetchAlerts();
  }, [currentPage]);

  const fetchAlerts = async () => {
    try {
      const data = await getRequest<{ alerts: Alert[]; totalPages: number }>(
        `/alerts?page=${currentPage}&limit=${pageSize}`,
      );
      if (data) {
        setAlerts(data.alerts);
        setTotalPages(data.totalPages);
      }
    } catch (error) {
      console.error('Error fetching alerts:', error);
    }
  };

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div>
      <h2 className="mb-3">Alerts</h2>

      <div className="pagination mb-1">
        <button
          className="btn btn-secondary"
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </button>
        <span className="mx-2">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className="btn btn-secondary"
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>

      <table className="table table-striped table-bordered">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Created At</th>
            <th>Incident</th>
            <th>Message</th>
            <th>Recipient</th>
          </tr>
        </thead>
        <tbody>
          {alerts.map((alert) => (
            <tr key={alert.id}>
              <td>{alert.id}</td>
              <td>{formatDate(alert.created_at)}</td>
              <td>{alert.incident?.id}</td>
              <td>{alert.message}</td>
              <td>{alert.recipient?.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Alerts;
